import { render, staticRenderFns } from "./InventoryReport.vue?vue&type=template&id=683e0b44&scoped=true"
import script from "./InventoryReport.vue?vue&type=script&lang=js"
export * from "./InventoryReport.vue?vue&type=script&lang=js"
import style0 from "./InventoryReport.vue?vue&type=style&index=0&id=683e0b44&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683e0b44",
  null
  
)

export default component.exports